export default __webpack_public_path__ + "static/media/icn-bath.831bc6d1.svg";